import AutocompleteSelect from "../shared/forms/AutocompleteSelect";
import { GroupWithId } from "../../interfaces/IGroups";

interface GroupSelectorProps {
  groups: GroupWithId[];
  selectedGroupId: string | null;
  onGroupChange: (groupId: string | null) => void;
  disabled?: boolean;
  label?: string;
}

/**
 * Komponent do wyboru grupy z listy dostępnych grup
 * Używa AutocompleteSelect dla wygodnego wyszukiwania i wyboru
 */
export default function GroupSelector({
  groups,
  selectedGroupId,
  onGroupChange,
  disabled = false,
  label = "Wybierz grupę",
}: GroupSelectorProps) {
  const selectedGroup = groups.find((g) => g.id === selectedGroupId) || null;

  return (
    <AutocompleteSelect<GroupWithId>
      disabled={disabled}
      options={groups}
      label={label}
      getOptionLabel={(group) => group.name}
      onChange={(group) => onGroupChange(group?.id || null)}
      noOptionsText="Nie masz grup..."
    />
  );
}

